import React, { ReactElement, useContext } from 'react'

import Heading from '../../Common/Components/Heading'
import Fieldset from '../../Common/Components/Fieldset'
import P from '../../Common/Components/P'
import Checkbox from '../../Common/Components/Checkbox'
import FormRow from '../../Common/Components/FormRow'

import { LanguageContext } from '../../Common/Contexts'

import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { StatisticCalculations as StatisticCalculationsLanguage } from '../../../../i18n'
import { HeadingLevel } from '../../Common/Components/Heading/Heading'

/**
 * Component properties type.
 */
type Props = {
    considerCallsMvdToUnresAsOverflwd: boolean
    setConsiderCallsMvdToUnresAsOverflwd: (checked: boolean) => void
}

/**
 * Statistic calculations section in Advanced tab of report configuration modal window.
 *
 * @param considerCallsMvdToUnresAsOverflwd Report property.
 * @param setConsiderCallsMvdToUnresAsOverflwd Setter for corresponding report property.
 */
const StatisticCalculations: React.FC<Props> = ({
    considerCallsMvdToUnresAsOverflwd,
    setConsiderCallsMvdToUnresAsOverflwd
}: Props): ReactElement => {
    const language = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle('StatisticCalculations')

    return (
        <Fieldset className={'statistic-calculations'}>
            <Heading level={HeadingLevel.ONE}>
                {language.get(StatisticCalculationsLanguage.StatisticCalculations_SectionHeader)}
            </Heading>
            <P>{language.get(StatisticCalculationsLanguage.StatisticCalculations_SectionPara)}</P>
            <FormRow isInline className={'consider-calls-moved-to-unresolved-as-overflowed'}>
                <Checkbox
                    onChange={setConsiderCallsMvdToUnresAsOverflwd}
                    isChecked={considerCallsMvdToUnresAsOverflwd}
                    labelLeft={language.get(StatisticCalculationsLanguage.ConsidermovedtounresolvedasoverflowedLabel)}
                />
            </FormRow>
        </Fieldset>
    )
}

export default React.memo(StatisticCalculations)
